var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcludeActiveIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.4142,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 4.266c-4.265 0-7.734 3.469-7.734 7.733s3.469 7.733 7.734 7.733c4.289 0 7.779-3.469 7.779-7.733s-3.49-7.733-7.779-7.733zm0.703 14.022v-1.368h-1.406v1.367c-2.929-0.325-5.26-2.657-5.585-5.585h1.366v-1.406h-1.366c0.325-2.928 2.656-5.259 5.585-5.585v1.367h1.406v-1.367c2.952 0.323 5.303 2.655 5.631 5.585h-1.367v1.402h1.367c-0.328 2.929-2.679 5.267-5.631 5.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.703 11.296v-2.812h-1.407v4.218h2.812v-1.406h-1.405z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.071 4.164 1.874 0.101 0.075-1.404-4.52-0.243 0.266 4.224 1.403-0.088-0.101-1.6c3.527 4.12 3.378 10.358-0.565 14.302-4.195 4.194-10.766 4.194-14.96 0-4.181-4.182-4.181-10.732 0-14.913 2.022-2.022 4.67-3.136 7.457-3.136v-1.406c-3.127 0-6.164 1.26-8.451 3.547-4.73 4.73-4.734 12.168 0 16.902 4.73 4.73 12.214 4.734 16.948 0 4.48-4.48 4.654-11.601 0.574-16.286z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcludeActiveIc);
export default __webpack_public_path__ + "static/media/conclude-active-ic.23684cd3d5810eedeab84e0c288405f3.svg";
export { ForwardRef as ReactComponent };